import { render, staticRenderFns } from "./coursemanagement.vue?vue&type=template&id=0a341af4"
import script from "./coursemanagement.vue?vue&type=script&lang=js"
export * from "./coursemanagement.vue?vue&type=script&lang=js"
import style0 from "./coursemanagement.vue?vue&type=style&index=0&id=0a341af4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports